import {VEDMARKET_LINKS} from '../../../constants';

export const DEMO_LINK = VEDMARKET_LINKS.demo;
export const PARTNER_REGISTER_LINK = 'https://my.vedmarket.ru/company/register';
